import { render, staticRenderFns } from "./iam-edit-page.vue?vue&type=template&id=47f5a4a0&"
import script from "./iam-edit-page.vue?vue&type=script&lang=js&"
export * from "./iam-edit-page.vue?vue&type=script&lang=js&"
import style0 from "./iam-edit-page.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./iam-edit-page.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QInput,QSelect,QBtn,QSpinnerIos,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QInput,QSelect,QBtn,QSpinnerIos,QField})
